{
  "common": {
    "title": "Charikaty",
    "welcome": "Bienvenue sur Charikaty",
    "login": "Connexion",
    "signup": "S'inscrire",
    "logout": "Déconnexion",
    "dashboard": "Tableau de bord",
    "settings": "Paramètres",
    "home": "Accueil",
    "loading": "Chargement...",
    "error": "Une erreur est survenue",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "workspace": "Espace de Travail",
    "sovereign_os": "Sovereign OS"
  },
  "nav": {
    "home": "Accueil",
    "platform": "Plateforme",
    "services": "Services",
    "about": "À propos",
    "contact": "Contact",
    "start_project": "Démarrer Projet",
    "theme_light": "Mode Clair",
    "theme_dark": "Mode Sombre",
    "language_selector": "Langue / Language",
    "lang_fr": "Français",
    "lang_en": "English",
    "lang_ar": "العربية",
    "logo_alt": "Logo Charikaty",
    "hero_backdrop_alt": "Fond Institutionnel Fintech",
    "close_menu_alt": "Fermer le menu",
    "pricing": "Tarifs"
  },
  "auth": {
    "login": {
      "title": "Accès Terminal",
      "subtitle": "Connectez-vous à votre infrastructure souveraine.",
      "email": "Adresse E-mail",
      "password": "Mot de passe",
      "forgot_password": "Mot de passe oublié ?",
      "submit": "Se connecter",
      "no_account": "Pas encore de compte ?",
      "signup_link": "Créer un compte",
      "error_invalid": "Identifiants invalides. Veuillez réessayer.",
      "error_system": "Erreur système. Veuillez contacter le support."
    },
    "signup": {
      "title": "Nouveau Compte",
      "subtitle": "Commencez votre voyage vers la souveraineté financière.",
      "initialization": "Initialisation du Profil",
      "step_title": "Étape {step} sur 2",
      "name": "Nom complet",
      "email": "Adresse E-mail",
      "password": "Mot de passe",
      "next": "Continuer",
      "back": "Retour",
      "submit": "Créer mon compte",
      "back_to_selection": "Retour au choix du profil",
      "have_account": "Déjà un compte ?",
      "login_link": "Se connecter",
      "error_select_profile": "Veuillez sélectionner un profil pour continuer.",
      "error_password_length": "Le mot de passe doit contenir au moins 8 caractères.",
      "error_institution_email": "Les institutions doivent utiliser une adresse e-mail officielle (.dz ou .gov).",
      "error_exists": "Un compte avec cet e-mail existe déjà."
    },
    "profiles": {
      "INDIVIDUAL": "Individuel",
      "individual_desc": "Investisseurs particuliers et porteurs de projets.",
      "AUTO_ENTREPRENEUR": "Auto-entrepreneur",
      "auto_entrepreneur_desc": "Indépendants et freelances.",
      "ENTERPRISE": "Entreprise",
      "enterprise_desc": "Startups, PME et grandes entreprises.",
      "INCUBATOR": "Incubateur",
      "incubator_desc": "Accélérateurs et structures d'accompagnement.",
      "INVESTOR": "Investisseur",
      "investor_desc": "Fonds d'investissement et Business Angels.",
      "INSTITUTION": "Institution",
      "institution_desc": "Organismes gouvernementaux et ministères."
    },
    "fields": {
      "full_name": "Nom complet",
      "full_name_placeholder": "Jean Dupont",
      "phone": "Numéro de téléphone",
      "phone_placeholder": "+213 -- -- -- --",
      "company_name": "Nom de l'entreprise",
      "company_name_placeholder": "Nom de votre structure",
      "type": "Type de structure",
      "country": "Pays de résidence",
      "country_default": "Algérie",
      "incubator_name": "Nom de l'incubateur",
      "incubator_name_placeholder": "Nom de votre accélérateur",
      "structure": "Type de structure",
      "investor_name": "Nom de l'investisseur / Fonds",
      "investor_name_placeholder": "Nom complet",
      "profile_type": "Type de profil",
      "experience": "Niveau d'expérience",
      "institution_name": "Nom de l'institution",
      "institution_name_placeholder": "Ministère / Organisme",
      "department": "Département / Direction",
      "department_placeholder": "Ex: Direction de l'innovation",
      "role": "Rôle / Fonction",
      "role_placeholder": "Directeur",
      "email_institutional": "E-mail institutionnel",
      "email_professional": "E-mail professionnel",
      "placeholder_email": "nom@domaine.com",
      "placeholder_password": "••••••••",
      "placeholder_name": "Jean Dupont",
      "password": "Mot de passe"
    },
    "options": {
      "startup": "Startup",
      "pme": "PME",
      "project": "Projet",
      "public": "Public",
      "private": "Privé",
      "individual": "Individuel",
      "fund": "Fonds / Groupe",
      "beginner": "Débutant",
      "advanced": "Avancé"
    },
    "demo": {
      "label": "Accès Démo Professionnel",
      "description": "Explorez la plateforme avec un profil d'entreprise pré-configuré.",
      "email_label": "Email",
      "password_label": "Mot de passe",
      "email": "demo@charikaty.com",
      "button": "Accéder en Démo",
      "account_name": "Compte Démo",
      "tooltip": "Compte de démonstration pour comité"
    },
    "forgot_password": {
      "title": "Récupération d'Accès",
      "subtitle": "Entrez votre e-mail pour recevoir un lien de réinitialisation.",
      "email_label": "Adresse E-mail",
      "email_placeholder": "nom@domaine.com",
      "submit": "Envoyer le lien",
      "back_to_login": "Retour à la connexion",
      "success_title": "E-mail Envoyé",
      "success_message": "Si un compte existe pour cet e-mail, vous recevrez un lien de réinitialisation sous peu.",
      "error_not_found": "Aucun compte trouvé avec cette adresse e-mail.",
      "error_system": "Une erreur est survenue lors de l'envoi de l'e-mail."
    },
    "reset_password": {
      "title": "Nouveau Mot de Passe",
      "subtitle": "Veuillez définir votre nouveau mot de passe sécurisé.",
      "new_password": "Nouveau mot de passe",
      "confirm_password": "Confirmer le mot de passe",
      "submit": "Réinitialiser le mot de passe",
      "success_title": "Succès",
      "success_message": "Votre mot de passe a été mis à jour avec succès.",
      "error_invalid_token": "Le lien de réinitialisation est invalide ou a expiré.",
      "error_mismatch": "Les mots de passe ne correspondent pas.",
      "error_system": "Une erreur est survenue lors de la réinitialisation."
    },
    "layout": {
      "visual_title": "L'Infrastructure de Confiance pour l'Économie Algérienne.",
      "visual_desc": "Un terminal unique pour piloter vos actifs financiers, juridiques et stratégiques avec une précision souveraine.",
      "feature_audit": "Audit institutionnel & Conformité",
      "feature_treasury": "Gestion de Trésorerie Avancée",
      "feature_investor": "Pools d'Investisseurs Certifiés",
      "back_to_site": "Retour au site principal",
      "protocol_label": "Protocole Charikaty • Déploiement Standardisé Mondial"
    },
    "admin_demo": {
      "label": "Accès Démo Administrateur",
      "description": "Réservé aux investisseurs, comités de startup et évaluateurs d'incubateur.",
      "button": "Accéder à la Démo Admin",
      "account_name": "Démo Administrateur",
      "tooltip": "Compte de démonstration pour l'administration",
      "email": "admin@charikaty.dz"
    }
  },
  "kyc": {
    "title": "Vérification d'Identité",
    "nif_label": "Numéro d'Identification Fiscale (NIF)",
    "nif_placeholder": "Entrez votre NIF",
    "nin_label": "Numéro d'Identification National (NIN)",
    "nin_placeholder": "Entrez votre NIN",
    "file_label_auto": "Carte d'Auto-entrepreneur (Scan/Photo)",
    "file_label_id": "Carte Nationale d'Identité (Recto/Verso)",
    "file_placeholder": "Glissez-déposez votre fichier ici ou cliquez pour parcourir",
    "file_error_size": "Le fichier est trop volumineux (Max 5Mo)",
    "file_error_format": "Format non supporté (JPG, PNG, PDF uniquement)",
    "submit": "Vérifier l'identité",
    "skip": "Passer pour le moment"
  },
  "kyc_profile": {
    "title": "Complétez votre profil",
    "subtitle": "Des informations supplémentaires sont requises pour votre type de profil."
  },
  "landing": {
    "hero": {
      "badge": "Infrastructure Souveraine",
      "title_main": "Pilotage stratégique pour",
      "title_accent": "l'entreprise moderne.",
      "description": "La plateforme intégrée pour la finance, le juridique et la fiscalité. Gérez toute votre structure souveraine avec une précision institutionnelle.",
      "cta_start": "Commencer",
      "cta_explore": "Explorer la plateforme"
    },
    "intro": {
      "label": "Analyse de Contexte",
      "title": "Opérations Unifiées.",
      "subtitle": "Charikaty élimine les silos entre vos opérations bancaires, juridiques et administratives. Un seul terminal pour propulser votre croissance de manière sécurisée.",
      "feature_1": {
        "title": "Inertie Opérationnelle",
        "desc": "Processus manuels automatisés pour une agilité accrue."
      },
      "feature_2": {
        "title": "Précision Fiscale",
        "desc": "Anticipation et automatisation des déclarations périodiques."
      },
      "feature_3": {
        "title": "Réseau Institutionnel",
        "desc": "Connexion directe aux investisseurs et partenaires certifiés."
      }
    },
    "pillars": {
      "label": "Écosystème de Croissance",
      "title": "Trois piliers fondamentaux.",
      "subtitle": "Une architecture modulaire conçue pour la résilience, la sécurité et la performance institutionnelle.",
      "legal": {
        "title": "Juridique Digital",
        "desc": "Cycle de vie juridique complet, de la création certifiée à la gestion des statuts."
      },
      "finance": {
        "title": "Finance & Fiscalité",
        "desc": "Visualisation prédictive et conformité fiscale automatisée en temps réel."
      },
      "invest": {
        "title": "Moteur d'Investissement",
        "desc": "Pools d'investissement certifiés et terminal de levée de fonds souverain."
      },
      "explore": "Explorer"
    },
    "targets": {
      "label": "Publics Cibles",
      "title": "Une solution pour chaque acteur.",
      "subtitle": "Le protocole Charikaty s'adapte dynamiquement à votre profil institutionnel.",
      "individual": {
        "title": "Individuel",
        "desc": "Investisseurs particuliers et porteurs de projets numériques."
      },
      "business": {
        "title": "Entreprise",
        "desc": "Startups, PME et grandes entreprises en croissance."
      },
      "incubator": {
        "title": "Incubateur",
        "desc": "Structures publiques et privées d'accompagnement."
      },
      "investor": {
        "title": "Investisseur",
        "desc": "Fonds, Business Angels et investisseurs intermédiaires."
      },
      "institution": {
        "title": "Institution",
        "desc": "Organismes gouvernementaux et ministères."
      }
    },
    "final_cta": {
      "title": "Prenez le contrôle souverain de votre écosystème dès aujourd'hui.",
      "subtitle": "Rejoignez l'infrastructure de référence pour les acteurs économiques modernes.",
      "button": "Créer mon compte"
    },
    "footer": {
      "tagline": "L'écosystème souverain de gestion d'entreprise intelligente.",
      "product": "Produit",
      "legal": "Légal",
      "contact": "Contact",
      "privacy": "Confidentialité",
      "security": "Sécurité",
      "terms": "Termes",
      "support": "Support",
      "audit": "Audit",
      "hq": "Siège HQ",
      "copyright": "© 2026 // Charikaty Sovereign OS. Conçu pour la croissance.",
      "privacy_policy": "Politique Privée",
      "audit_security": "Audit & Sécurité"
    },
    "city_data": {
      "network_hub": "Network Hub v2.4 // ALGÉRIE",
      "alger": "Alger",
      "oran": "Oran",
      "mostaganem": "Mostaganem",
      "tlemcen": "Tlemcen",
      "sidi_bel_abbes": "Sidi Bel Abbès",
      "stats": {
        "population": "Population Hub",
        "startups": "Synergie Startups",
        "funding": "Accès Capital",
        "strategic_index": "Index Stratégique",
        "rank": "RANG {n}"
      }
    }
  },
  "legal_page": {
    "header": {
      "title": "CENTRE DE CONFORMITÉ",
      "subtitle": "Trust & Transparency Layer",
      "version": "v{version}",
      "last_update": "Dernière mise à jour: {date}",
      "full_dossier": "Dossier Légal"
    },
    "sidebar": {
      "nav_label": "Navigation",
      "identity": "Identité Légale",
      "terms": "Conditions Générales",
      "privacy": "Confidentialité",
      "data": "Usage des Données",
      "rights": "Droits Utilisateurs",
      "downloads": "Documents PDF",
      "contact": "Contact Juridique",
      "status_valid": "Conformité Validée",
      "status_desc": "Système certifié conforme aux normes de protection des données financières (Algérie 2024-2026)."
    },
    "identity": {
      "badge": "Section 01",
      "title": "Identité de la Plateforme",
      "subtitle": "Informations d'enregistrement et entité légale opérant le système.",
      "company_name_label": "Raison Sociale",
      "company_name": "Charikaty Sovereign OS Technologies Inc.",
      "subsidiary": "Filiale de GSD Group (Global Sovereign Digital)",
      "jurisdiction_label": "Jurisdiction",
      "jurisdiction": "Alger, Algérie"
    },
    "terms": {
      "badge": "Section 02",
      "title": "Conditions Générales",
      "pdf_button": "CGU (PDF)",
      "items": [
        {
          "title": "Usage Autorisé",
          "content": "L'utilisation de Charikaty est strictement réservée à la gestion d'entreprise et au conseil financier institutionnel."
        },
        {
          "title": "Propriété Intellectuelle",
          "content": "Tous les composants IA (LegalDZ, Genvest) sont protégés par le droit d'auteur international et local."
        },
        {
          "title": "Souveraineté Numérique",
          "content": "L'utilisateur accepte que ses données ne quittent jamais le périmètre infrastructurel souverain de l'Algérie."
        },
        {
          "title": "Résiliation",
          "content": "En cas de manquement grave aux lois de finance en vigueur, l'accès peut être suspendu sans préavis."
        }
      ]
    },
    "privacy": {
      "badge": "Section 03 & 04",
      "title": "Politique de Confidentialité",
      "subtitle": "Nous appliquons des standards militaires pour la protection de vos données. Voici comment nous traitons vos informations.",
      "consent_title": "Gestion du Consentement",
      "consent_labels": {
        "analytics": "Analyse d'audience",
        "marketing": "Marketing & Offres",
        "security": "Sécurité Système"
      },
      "rights_title": "Vos Droits (Loi 18-07)",
      "rights_list": [
        "Droit d'accès intégral à vos données",
        "Droit de rectification immédiate",
        "Droit à l'oubli (après audit légal)",
        "Portabilité des données vers tiers certifiés"
      ],
      "inventory_title": "Inventaire de Données",
      "table": {
        "headers": {
          "type": "Type de donnée",
          "purpose": "Finalité",
          "duration": "Durée"
        },
        "rows": [
          {
            "type": "Identité Fiscale",
            "purpose": "Vérification de l'entité légale",
            "duration": "Durée de l'abonnement + 10 ans"
          },
          {
            "type": "Flux Financiers",
            "purpose": "Optimisation prédictive (Genvest)",
            "duration": "7 ans (Obligation Fiscale)"
          },
          {
            "type": "Logs de Connexion",
            "purpose": "Sécurité et audit de fraude",
            "duration": "24 mois"
          }
        ]
      }
    },
    "downloads": {
      "badge": "Section 06",
      "title": "Téléchargements Légaux",
      "subtitle": "Documents officiels, certificats de conformité et attestations de souveraineté.",
      "full_dossier": "Dossier Légal Complet",
      "privacy_pdf": "Confidentialité (PDF)",
      "terms_pdf": "Conditions Générales"
    },
    "contact": {
      "badge": "Section 07",
      "title": "Contact Département Juridique",
      "subtitle": "Une question sur la conformité ? Un signalement de faille de sécurité ? Utilisez ce canal prioritaire.",
      "labels": {
        "full_name": "Nom Complet",
        "email": "Email Institutionnel",
        "subject": "Sujet de la demande",
        "message": "Message Détaillé"
      },
      "placeholders": {
        "full_name": "M. Brahim K. / Cabinet Juridique X",
        "email": "contact@entreprise.dz",
        "subject": "e.g. Demande d'audit de données RGPD/Algérie",
        "message": "Décrivez votre demande avec précision..."
      },
      "secure_label": "Transmission sécurisée (TLS 1.3)",
      "submit": "Envoyer la requête",
      "validation": {
        "name_short": "Le nom est trop court (min. 3 caractères)",
        "email_invalid": "Veuillez entrer une adresse e-mail valide",
        "subject_short": "Le sujet est trop court (min. 5 caractères)",
        "message_short": "Le message est trop court (min. 20 caractères)"
      }
    },
    "toasts": {
      "pdf_success": "Document généré avec succès",
      "pdf_desc": "Téléchargement de {type}.pdf en cours...",
      "contact_success": "Demande envoyée au département juridique",
      "contact_desc": "Nous reviendrons vers vous sous 48h ouvrées.",
      "consent_success": "Préférence mise à jour",
      "consent_desc": "{key} est désormais {status}."
    },
    "footer": {
      "copyright": "© 2026 Charikaty Technologies. Opéré sous jurisdiction Algérienne.",
      "status": "Statut Système",
      "certificates": "Portail Certificats",
      "api_compliance": "API Compliance",
      "tagline": "Sovereign Operating System Infrastructure — Trust Layer"
    }
  },
  "contact_page": {
    "header": {
      "title": "Contactez Nous",
      "subtitle": "Une question technique, juridique ou financière ? Nos experts sont à votre disposition pour un accompagnement sur mesure."
    },
    "info": {
      "title": "Informations de contact",
      "hq": {
        "title": "Siège Social",
        "address": "Quartier des Affaires, Tour Charikaty, Alger, Algérie"
      },
      "phone": {
        "title": "Téléphone",
        "hours": "Lun-Jeu: 8h30 - 17h00"
      },
      "email": {
        "title": "Email Institutionnel",
        "support": "Support 24/7 pour les comptes Premium"
      }
    },
    "form": {
      "title": "Envoyer un message",
      "labels": {
        "name": "Nom complet",
        "email": "Email professionnel",
        "message": "Votre message"
      },
      "placeholders": {
        "name": "Ex: Amina Benali",
        "email": "Ex: a.benali@entreprise.dz",
        "message": "Comment pouvons-nous vous aider ?"
      },
      "submit": "Envoyer le message",
      "submitting": "Envoi en cours..."
    },
    "toasts": {
      "error_title": "Erreur de validation",
      "error_desc": "Veuillez remplir tous les champs obligatoires.",
      "success_title": "Message envoyé",
      "success_desc": "Notre équipe institutionnelle vous répondra dans les plus brefs délais."
    },
    "categories": {
      "legal": {
        "title": "Juridique",
        "desc": "Aide à la création et aux statuts"
      },
      "finance": {
        "title": "Finance",
        "desc": "Questions sur la trésorerie et la fiscalité"
      },
      "invest": {
        "title": "Investissement",
        "desc": "Support module Genvest et capital-risque"
      }
    },
    "faq": {
      "title": "Base de Connaissances",
      "search_placeholder": "Rechercher une réponse...",
      "no_results": "Aucun résultat pour \"{query}\"",
      "items": [
        {
          "category": "legal",
          "question": "Comment les statuts générés sont-ils certifiés ?",
          "answer": "Les statuts générés par Charikaty utilisent LegalDz IA, formé sur le code de commerce algérien en vigueur. Ils sont pré-formatés pour être acceptés par les notaires et le CNRC, bien qu'une signature notariée finale reste obligatoire par la loi."
        },
        {
          "category": "finance",
          "question": "Puis-je lier mon compte bancaire professionnel ?",
          "answer": "Oui, la plateforme permet l'intégration via une API bancaire sécurisée pour synchroniser vos flux de trésorerie en temps réel, garantissant une vue exacte de votre santé financière."
        },
        {
          "category": "account",
          "question": "Comment ajouter des collaborateurs à mon espace ?",
          "answer": "Allez dans « Paramètres » > « Équipe », puis cliquez sur « Inviter un membre ». Vous pourrez définir des rôles stricts (ex. Lecture seule, Comptable, Administrateur) via notre système RBAC."
        },
        {
          "category": "legal",
          "question": "Le simulateur fiscal est-il précis ?",
          "answer": "Le simulateur prend en compte le régime IBS/IRG, la TAP et les cotisations CASNOS/CNAS selon la législation en vigueur de la Loi de Finances. Les taux sont mis à jour dynamiquement."
        }
      ]
    },
    "ticket": {
      "title": "Ouvrir un Ticket",
      "subtitle": "Vous ne trouvez pas la réponse ? Contactez notre support technique.",
      "labels": {
        "category": "Catégorie du problème",
        "subject": "Objet de la demande",
        "description": "Description détaillée"
      },
      "categories": {
        "bug": "Problème technique (Bug)",
        "legal": "Assistance juridique / Génération",
        "billing": "Facturation et abonnements",
        "other": "Autre demande"
      },
      "placeholders": {
        "subject": "Ex : Erreur lors de la validation du nom",
        "description": "Décrivez votre problème en détail..."
      },
      "submit": "Soumettre le ticket",
      "submitting": "Création du ticket..."
    }
  },
  "support_page": {
    "header": {
      "title": "Centre de Support",
      "subtitle": "Documentation technique, questions fréquentes et assistance personnalisée."
    },
    "categories": {
      "legal": {
        "title": "Juridique",
        "desc": "Aide sur la création et statuts"
      },
      "finance": {
        "title": "Finance",
        "desc": "Questions sur la trésorerie et fiscalité"
      },
      "invest": {
        "title": "Investissement",
        "desc": "Support module Genvest et VC"
      }
    },
    "faq": {
      "title": "Base de connaissances",
      "search_placeholder": "Rechercher une réponse...",
      "no_results": "Aucun résultat pour \"{query}\"",
      "items": [
        {
          "category": "juridique",
          "question": "Comment les statuts générés sont-ils certifiés ?",
          "answer": "Les statuts générés par Charikaty utilisent LegalDz AI, entraîné sur le code de commerce algérien en vigueur. Ils sont pré-formatés pour être acceptés par les notaires et le CNRC, bien qu'une signature notariée finale reste obligatoire selon la loi."
        },
        {
          "category": "finance",
          "question": "Puis-je lier mon compte bancaire d'entreprise ?",
          "answer": "Oui, la plateforme permet l'intégration via API bancaire sécurisée pour synchroniser vos flux de trésorerie en temps réel, garantissant une vue exacte de votre santé financière."
        },
        {
          "category": "compte",
          "question": "Comment ajouter des collaborateurs à mon espace ?",
          "answer": "Allez dans \"Paramètres\" > \"Équipe\", puis cliquez sur \"Inviter un membre\". Vous pourrez définir des rôles stricts (ex: Lecture seule, Comptable, Administrateur) via notre système RBAC."
        },
        {
          "category": "juridique",
          "question": "Le simulateur fiscal est-il précis ?",
          "answer": "Le simulateur prend en compte le régime IBS/IRG, la TAP, et les cotisations CASNOS/CNAS selon la législation actuelle de la Loi de Finances. Les taux sont mis à jour dynamiquement."
        }
      ]
    },
    "ticket": {
      "title": "Ouvrir un ticket",
      "subtitle": "Vous ne trouvez pas la réponse ? Contactez notre support technique.",
      "labels": {
        "category": "Catégorie du problème",
        "subject": "Sujet de la demande",
        "description": "Description détaillée"
      },
      "categories": {
        "bug": "Problème technique (Bug)",
        "legal": "Assistance juridique / Génération",
        "billing": "Facturation et abonnements",
        "other": "Autre demande"
      },
      "placeholders": {
        "subject": "Ex: Erreur lors de la validation du nom",
        "description": "Expliquez votre problème en détail..."
      },
      "submit": "Soumettre le ticket",
      "submitting": "Création du ticket..."
    },
    "toasts": {
      "error_title": "Erreur",
      "error_desc": "Veuillez saisir un sujet pour votre ticket.",
      "success_title": "Ticket créé",
      "success_desc": "Votre demande de support #T-9842 a été enregistrée. Un agent vous contactera."
    }
  },
  "audit_page": {
    "title": "Registre d'Audit",
    "subtitle": "Transparence totale sur les opérations de l'infrastructure et l'intégrité du système Charikaty.",
    "section_title": "Logs d'Intégrité",
    "section_subtitle": "Vue publique des événements système majeurs.",
    "filters": {
      "all": "Tous",
      "security": "Sécurité",
      "system": "Système",
      "auth": "Accès"
    },
    "types": {
      "security": "Sécurité",
      "system": "Système",
      "auth": "Authentification"
    },
    "logs": {
      "messages": {
        "ssl_update": "Mise à jour des certificats SSL/TLS",
        "db_backup": "Sauvegarde chiffrée de la base de données",
        "auth_failed": "Tentative de connexion échouée (IP bloquée)",
        "security_patch": "Déploiement du patch de sécurité v2.4.1",
        "gdpr_audit": "Audit automatique de conformité RGPD",
        "latency_detected": "Latence détectée sur le noeud AP-Est"
      },
      "time": {
        "ago_2_min": "Il y a 2 min",
        "ago_15_min": "Il y a 15 min",
        "ago_1h": "Il y a 1h",
        "yesterday": "Hier",
        "ago_2_days": "Il y a 2 jours"
      }
    },
    "load_more": "Charger l'historique complet"
  },
  "privacy_page": {
    "title": "Politique de Confidentialité",
    "subtitle": "Vos données sont votre propriété. Nous en sommes les gardiens, pas les propriétaires.",
    "usage": {
      "title": "Utilisation des données",
      "desc": "Nous collectons uniquement les données strictement nécessaires au fonctionnement de nos services financiers et juridiques. Aucune donnée n'est revendue à des tiers.",
      "items": {
        "profile": "Profil d'entreprise",
        "transactions": "Historique transactionnel",
        "documents": "Documents légaux générés"
      }
    },
    "rights": {
      "title": "Vos droits garantis",
      "desc": "Conformément aux normes internationales (RGPD) et locales, vous disposez d'un contrôle total sur vos informations personnelles et institutionnelles.",
      "items": {
        "access": "Droit d'accès et de rectification",
        "erasure": "Droit à l'effacement (droit à l'oubli)",
        "portability": "Droit à la portabilité des données"
      }
    },
    "manager": {
      "button": "Gérer mes données et préférences",
      "title": "Centre de Préférences",
      "subtitle": "Gérez finement la collecte de vos données.",
      "essential": {
        "title": "Cookies Essentiels",
        "desc": "Requis pour le fonctionnement de base de la plateforme (authentification, sécurité)."
      },
      "analytics": {
        "title": "Analytique & Performance",
        "desc": "Nous aide à comprendre l'utilisation pour améliorer nos services."
      },
      "marketing": {
        "title": "Marketing & Offres",
        "desc": "Permet de recevoir des recommandations de services partenaires adaptés."
      },
      "third_party": {
        "title": "Intégrations Tiers",
        "desc": "Autorise le partage de données avec les applications externes connectées à votre espace."
      },
      "cancel": "Annuler",
      "save": "Enregistrer les choix",
      "toasts": {
        "save_success": "Préférences de confidentialité enregistrées",
        "save_desc": "Vos choix ont été mis à jour avec succès sur nos serveurs."
      }
    }
  },
  "hq_page": {
    "header": {
      "title": "Siège HQ",
      "subtitle": "Le centre névralgique de Charikaty Sovereign OS Technologies."
    },
    "algiers": "Alger, Algérie",
    "sections": {
      "address": {
        "title": "Adresse Physique",
        "content": "Quartier des Affaires Bab Ezzouar\nTour Charikaty, Étages 12-15\n16024 Alger"
      },
      "phone": {
        "title": "Standard Téléphonique",
        "content": "Principal: +213 (0) 21 00 00 00\nRelations Publiques: +213 (0) 21 00 00 01"
      },
      "email": {
        "title": "Courrier Électronique",
        "content": "Presse: presse@charikaty.dz\nPartenariats: partners@charikaty.dz"
      }
    },
    "cta": "Obtenir l'itinéraire (Maps)",
    "building_name": "Tour Charikaty",
    "coordinates": "36.7139° N, 3.1906° E"
  },
  "security_page": {
    "header": {
      "title": "Sécurité & Infrastructure",
      "subtitle": "Une architecture Zero-Trust conçue pour la protection des actifs critiques."
    },
    "features": [
      {
        "title": "Chiffrement E2E",
        "desc": "AES-256 bits pour toutes les données au repos et en transit."
      },
      {
        "title": "Résilience Multi-AZ",
        "desc": "Redondance active-active sur plusieurs zones géographiques."
      },
      {
        "title": "Monitoring 24/7",
        "desc": "Détection d'anomalies propulsée par l'IA en temps réel."
      }
    ],
    "status": {
      "title": "Statut du Système",
      "subtitle": "Vérification de l'intégrité de l'infrastructure en temps réel.",
      "operational": "100% OPÉRATIONNEL"
    },
    "services": [
      {
        "label": "Passerelle API Principale",
        "status": "Optimal"
      },
      {
        "label": "Cluster Base de Données",
        "status": "Sécurisé"
      },
      {
        "label": "Système d'Authentification",
        "status": "Optimal"
      }
    ],
    "check": {
      "button": "Vérifier la sécurité globale",
      "analyzing": "Analyse en cours...",
      "success": "Aucune vulnérabilité détectée"
    }
  },
  "terms_page": {
    "header": {
      "title": "Conditions d'Utilisation",
      "subtitle": "Règles et responsabilités liées à l'utilisation de la plateforme."
    },
    "sections": [
      {
        "title": "1. Acceptation des conditions",
        "content": "En accédant à l'infrastructure Charikaty, vous acceptez de vous conformer aux présentes conditions générales. Notre plateforme fournit des outils de gestion financière, juridique et fiscale à destination des professionnels."
      },
      {
        "title": "2. Responsabilités de l'utilisateur",
        "content": "L'utilisateur s'engage à fournir des informations exactes lors de la création de son espace souverain. L'utilisation de faux documents à des fins de génération de statuts ou de simulation fiscale entraînera la suspension immédiate du compte."
      },
      {
        "title": "3. Propriété intellectuelle",
        "content": "L'ensemble des algorithmes, interfaces et modèles générés par Charikaty (y compris via le module LegalDz AI) demeurent la propriété exclusive de Charikaty Sovereign OS Technologies Inc."
      }
    ],
    "consent": {
      "title": "Consentement",
      "subtitle": "Veuillez confirmer que vous avez lu et accepté nos conditions pour continuer à utiliser nos services de manière optimale.",
      "accepted_status": "Conditions actuellement acceptées",
      "refuse": "Refuser",
      "accept": "Accepter"
    },
    "toasts": {
      "success_title": "Conditions acceptées",
      "success_desc": "Merci d'avoir validé nos conditions générales d'utilisation.",
      "error_title": "Conditions refusées",
      "error_desc": "Certaines fonctionnalités de la plateforme peuvent être restreintes."
    }
  },
  "dashboard": {
    "account_menu": {
      "profile": "Mon profil",
      "aria_label": "Menu compte"
    },
    "topbar": {
      "dashboard": "Tableau de Bord",
      "legal": "Gérance d'Entreprises",
      "finance": "Trésorerie & Finance",
      "genvest": "Gérance d'Investissement",
      "operational": "Opérationnel",
      "search_placeholder": "Rechercher une entité, un flux...",
      "light_mode": "Mode Clair",
      "dark_mode": "Mode Sombre"
    },
    "nav": {
      "overview": "Aperçu",
      "infrastructure": "Infrastructure",
      "dashboard": "Tableau de bord",
      "legal": "Juridique",
      "companies": "Entreprises",
      "finance": "Finance",
      "genvest": "Genvest",
      "menu": "Menu",
      "home": "Accueil",
      "my_documents": "Mes Documents",
      "my_companies": "Mes Entreprises",
      "my_treasury": "Ma Trésorerie",
      "my_assets": "Mes Actifs",
      "settings": "Paramètres",
      "legal_overview": "Navigation",
      "trademark_validation": "Validation de Marque",
      "ai_assistant": "Assistant IA",
      "legal_simulation": "Simulation Juridique",
      "create_company": "Créer une Entreprise",
      "legal_events": "Événements Juridiques",
      "documents": "Documents",
      "our_partners": "Nos Partenaires",
      "integrations": "Intégrations",
      "compliance": "Conformité",
      "finance_home": "Accueil Finance",
      "strategic_alerts": "Alertes Stratégiques",
      "financial_management": "Gestion Financière",
      "advisor_insight": "Assistant Financier",
      "treasury": "Trésorerie",
      "project_evaluation": "Évaluation de Projet",
      "project_financial_study": "Étude Financière de Projet",
      "e_taxes": "E-Taxes",
      "financial_reports": "Rapports Financiers",
      "performance_indicators": "Indicateurs de Performance",
      "portfolio_simulation": "Simulation de Portefeuille",
      "creation": "Création",
      "portfolio": "Portefeuille",
      "risks": "Risques",
      "risk_simulation": "Simulation de Risque",
      "ai_predictive": "Analyse & Prédiction IA",
      "market": "Marché",
      "institutional_funding": "Financement Institutionnel",
      "infra_cockpit": "Cockpit Infra",
      "databases": "Bases de Données",
      "security": "Sécurité",
      "crm_users": "CRM & Utilisateurs",
      "connectivity": "Connectivité",
      "recovery": "Récupération",
      "logout": "Déconnexion",
      "cockpit": "Cockpit"
    },
    "desc": {
      "dashboard": "Cockpit Global",
      "my_documents": "Centre de Ressources",
      "my_companies": "Entités Juridiques",
      "my_treasury": "Santé Financière",
      "my_assets": "Gestion d'Actifs",
      "settings": "Compte & Préférences",
      "legal_overview": "Gestion Juridique Globale",
      "trademark_validation": "Vérifier Nom, Marque & Domaine",
      "ai_assistant": "Intelligence Juridique",
      "legal_simulation": "Tests de Faisabilité",
      "create_company": "Lancer une Structure",
      "legal_events": "Procès-Verbaux, AG & Statuts",
      "documents": "Coffre-fort & Modèles",
      "our_partners": "Réseau d'Experts",
      "integrations": "Passerelles API",
      "compliance": "Veille & Obligations",
      "finance_home": "Indicateurs Clés",
      "strategic_alerts": "Points d'Attention",
      "financial_management": "Comptes Clients/Fournisseurs",
      "advisor_insight": "Aide à la Décision Financière",
      "treasury": "Flux de Trésorerie Temps Réel",
      "project_evaluation": "ROI & Risques",
      "project_financial_study": "Investissements Internes",
      "e_taxes": "Déclarations Fiscales",
      "financial_reports": "Archives & Exports",
      "performance_indicators": "Analyse Approfondie",
      "institutional_partners": "Experts Institutionnels",
      "portfolio_simulation": "Construire une Stratégie",
      "creation_portfolio": "Créer votre Portefeuille",
      "portfolio_follow": "Suivi et Gestion",
      "exposure_analysis": "Analyse d'Exposition",
      "risk_scenarios": "Scénarios de Risque",
      "strategic_analytics": "Analyses Stratégiques",
      "live_stream": "Flux en Direct",
      "sovereign_pipeline": "Pipeline Souverain",
      "strategic_partners": "Partenaires Stratégiques",
      "infra_core": "Cœur de la Plateforme",
      "distributed_systems": "Systèmes Distribués",
      "cybersecurity": "Cybersécurité",
      "customer_engine": "Moteur Relation Client",
      "load_balancing": "Répartition de Charge",
      "backup_plan": "Plan de Sauvegarde & Reprise"
    },
    "sections": {
      "main_management": "GESTION PRINCIPALE",
      "intelligence_compliance": "INTELLIGENCE & CONFORMITÉ",
      "partners_ecosystem": "PARTENAIRES & ÉCOSYSTÈME",
      "financial_operations": "OPÉRATIONS FINANCIÈRES",
      "strategic_intelligence": "INTELLIGENCE STRATÉGIQUE",
      "analysis_projects": "ANALYSE & PROJETS",
      "ecosystem": "ÉCOSYSTÈME",
      "operations_assets": "OPÉRATIONS & ACTIFS",
      "analysis_simulation": "ANALYSE & SIMULATION",
      "market_ecosystem": "MARCHÉ & ÉCOSYSTÈME",
      "navigation": "Navigation"
    },
    "overview": {
      "title": "Tableau de Bord",
      "subtitle": "Vue d'ensemble de votre écosystème Charikaty",
      "access_module": "ACCÉDER AU MODULE",
      "legal_desc": "Gestion d'entités, conformité et simulateurs juridiques.",
      "finance_desc": "Gestion financière, rapports et indicateurs de performance.",
      "genvest_desc": "Investissements, analyse de portefeuille et opportunités.",
      "infra_desc": "Surveillance système, sécurité et connectivité.",
      "settings_desc": "Configuration du compte, préférences et sécurité."
    },
    "legal_page": {
      "title": "Entreprises & Juridique",
      "description": "Passerelle sécurisée vers les modules de gouvernance et de gestion légale des entreprises.",
      "badge": "GOUVERNANCE",
      "modules": {
        "nav": {
          "title": "Navigation",
          "desc": "Vue d'ensemble et pilotage du module juridique"
        },
        "brand": {
          "title": "Validation de marque",
          "desc": "Vérification de disponibilité et protection de marque"
        },
        "ai": {
          "title": "Assistant IA",
          "desc": "Conseiller juridique intelligent basé sur l'IA"
        },
        "sim": {
          "title": "Simulation juridique",
          "desc": "Simulateur de structures et d'impacts légaux"
        },
        "create": {
          "title": "Créer une entreprise",
          "desc": "Lancement et constitution de nouvelles entités"
        },
        "events": {
          "title": "Événements juridiques",
          "desc": "Gestion des assemblées, mutations et actes"
        },
        "docs": {
          "title": "Documents",
          "desc": "Coffre-fort et génération de documents officiels"
        },
        "partners": {
          "title": "Nos Partenaires",
          "desc": "Réseau d'experts et partenaires stratégiques"
        },
        "integrations": {
          "title": "Intégrations",
          "desc": "Connexion avec les systèmes externes et API"
        },
        "compliance": {
          "title": "Conformité",
          "desc": "Suivi réglementaire et audits de conformité"
        }
      }
    },
    "finance_page": {
      "title": "Console Finance",
      "description": "Pilotage de la performance, conformité fiscale et aide à la décision stratégique pour votre entreprise.",
      "badge": "EN DIRECT",
      "modules": {
        "acc": {
          "title": "Hub Comptable",
          "desc": "Gestion de la comptabilité et des flux financiers"
        },
        "advisor": {
          "title": "Charikaty Advisor",
          "desc": "Intelligence artificielle d'aide à la décision"
        },
        "cash": {
          "title": "Gestion de Trésorerie",
          "desc": "Suivi des liquidités et prévisions de cash-flow"
        },
        "eval": {
          "title": "Évaluation de Projets",
          "desc": "Analyse de rentabilité et simulation d'investissements"
        },
        "projects": {
          "title": "Projets d'Investissement",
          "desc": "Suivi opérationnel des projets en cours"
        },
        "taxes": {
          "title": "E-Impôts & Fiscalité",
          "desc": "Déclarations fiscales et conformité G50"
        },
        "reports": {
          "title": "Rapports Financiers",
          "desc": "Bilans, comptes de résultat et liasses fiscales"
        },
        "indicators": {
          "title": "Indicateurs & Données",
          "desc": "Visualisation des KPI et mesures de performance"
        },
        "alerts": {
          "title": "Alertes Stratégiques",
          "desc": "Gestion des alertes et notifications financières"
        },
        "partners": {
          "title": "Partenaires Financiers",
          "desc": "Écosystème bancaire et institutionnel"
        }
      }
    },
    "genvest_page": {
      "title": "Commande GenVest",
      "description": "Console de pilotage stratégique des actifs et simulations prédictives de marché.",
      "badge": "SYSTÈME ACTIF",
      "modules": {
        "portfolio": {
          "title": "Portefeuille Actif",
          "desc": "Gestion des positions et suivi de performance en temps réel"
        },
        "ai": {
          "title": "IA Prédictive",
          "desc": "Signaux d'investissement et analyse prédictive quantitative"
        },
        "opportunities": {
          "title": "Opportunités de Marché",
          "desc": "Intelligence stratégique et détection de croissance"
        },
        "risks": {
          "title": "Analyse des Risques",
          "desc": "Surveillance de l'exposition et conformité réglementaire"
        },
        "sim_port": {
          "title": "Simulation de Portefeuille",
          "desc": "Simulateur d'allocation d'actifs et projection de rendement"
        },
        "sim_risk": {
          "title": "Simulation de Risque",
          "desc": "Stress-tests et simulation d'impact de scénarios critiques"
        },
        "deal": {
          "title": "Deal Flow Institutionnel",
          "desc": "Accès au financement institutionnel et levées de fonds"
        },
        "creation": {
          "title": "Création de Portefeuille",
          "desc": "Workflow de création et constitution de nouveaux fonds"
        },
        "integrations": {
          "title": "Intégrations & API",
          "desc": "Connexion aux flux de données et systèmes externes"
        },
        "alerts": {
          "title": "Alertes Stratégiques",
          "desc": "Système de surveillance et notifications de risques critiques"
        }
      }
    },
    "settings_page": {
      "title": "Paramètres & Sécurité",
      "description": "Gérez les informations de votre entreprise, les accès, et les préférences de sécurité de votre compte.",
      "legal": {
        "title": "Cadre Juridique & Gouvernance",
        "subtitle": "Droit Commercial Algérien",
        "regime_label": "Régime Réglementaire",
        "rc_option": "DROIT COMMERCIAL (RC)",
        "zes_option": "ZONE ÉCONOMIQUE SPÉCIALE (ZES)",
        "sig_label": "Signature Numérique",
        "sig_status": "Certificat ANC Actif",
        "save_btn": "Enregistrer les paramètres"
      },
      "services": {
        "title": "Services & Automatisations",
        "subtitle": "Modules de gestion actifs",
        "mod1": {
          "name": "Surveillance Tracfin",
          "desc": "Vigilance automatique des transactions"
        },
        "mod2": {
          "name": "Calcul de l'Impôt G50",
          "desc": "Provisionnement fiscal automatique"
        },
        "mod3": {
          "name": "Synchro RC",
          "desc": "Lien direct avec le Registre de Commerce"
        },
        "mod4": {
          "name": "Audit IA",
          "desc": "Détection intelligente d'anomalies"
        },
        "active": "ACTIF",
        "inactive": "DÉSACTIVÉ"
      },
      "system": {
        "title": "État du Système",
        "node1": "Serveur Principal",
        "node2": "Passerelle DGI",
        "node3": "Moteur de Calcul",
        "status_optimal": "Optimal",
        "status_connected": "Connecté",
        "status_stable": "Stable",
        "api_btn": "Générer les clés API"
      },
      "security": {
        "title": "Sécurité",
        "desc": "Votre compte utilise un chiffrement de niveau bancaire. Évitez de partager vos accès.",
        "status": "Chiffrement Actif"
      },
      "support": {
        "label": "Besoin d'aide ?",
        "desc": "Nos techniciens sont disponibles pour vous assister dans la configuration.",
        "btn": "Contacter le support"
      }
    },
    "ai_legal_page": {
      "title": "Legal DZ AI",
      "description": "Assistant juridique souverain propulsé par l'IA",
      "system": "DZ-LEGAL-CORE",
      "infrastructure": "INFRASTRUCTURE",
      "active": "ACTIVE",
      "mission_vision": "MISSION & VISION",
      "mission_headline_1": "ANALYSE",
      "mission_headline_2": "JURIDIQUE",
      "mission_headline_3": "SOUVERAINE",
      "mission_text": "Legal DZ AI est conçu pour répondre aux spécificités du droit commercial local, garantissant une conformité totale.",
      "garanties": "GARANTIES DU SYSTÈME",
      "garanties_list": {
        "g1": "Données hébergées localement",
        "g2": "Conformité CNPD",
        "g3": "Mises à jour quotidiennes"
      },
      "button": "ACCÉDER À LA PLATEFORME",
      "redirection": "REDIRECTION VERS DZ-LEGAL-AI.COM",
      "capabilities": {
        "c1": {
          "title": "Analyse Immédiate",
          "status": "ACTIF",
          "desc": "Traitement instantané de documents juridiques complexes."
        },
        "c2": {
          "title": "Rédaction Assistée",
          "status": "OPÉRATIONNEL",
          "desc": "Génération de contrats et d'actes."
        },
        "c3": {
          "title": "Veille Réglementaire",
          "status": "SYNC",
          "desc": "Suivi en temps réel du Journal Officiel algérien."
        },
        "c4": {
          "title": "Recherche Intelligente",
          "status": "EN LIGNE",
          "desc": "Accès à une base de données de jurisprudence."
        }
      },
      "metrics_title": "PERFORMANCE DU SYSTÈME",
      "version": "VERSION V2.4",
      "metrics": {
        "m1": {
          "label": "PRÉCISION",
          "value": "99.8%",
          "sub": "TAUX DE RÉUSSITE"
        },
        "m2": {
          "label": "LATENCE",
          "value": "120ms",
          "sub": "TEMPS DE RÉPONSE"
        },
        "m3": {
          "label": "TOKENS",
          "value": "1.2M",
          "sub": "/ SECONDE"
        }
      },
      "integration_title": "INTÉGRATION PROFONDE",
      "integration_depth": "PROFONDEUR D'ANALYSE",
      "integration_sync": "SYNC TOTALE",
      "integration_text": "Le moteur IA est directement couplé à la base de données de votre entreprise pour une pertinence contextuelle maximale.",
      "next_step_title": "PROCHAINE ÉTAPE",
      "next_step_desc": "Intégration prévue des modules de contentieux au T3."
    }
  },
  "brand_val": {
    "report_title": "RAPPORT D'AUDIT DE DÉNOMINATION",
    "official_document": "Document Officiel de Simulation",
    "government_header": "RÉPUBLIQUE ALGÉRIENNE DÉMOCRATIQUE ET POPULAIRE",
    "ministry_header": "MINISTÈRE DU COMMERCE ET DE LA PROMOTION DES EXPORTATIONS",
    "cnrc_header": "CENTRE NATIONAL DU REGISTRE DU COMMERCE",
    "id": "Identifiant Simulation",
    "date": "Date de Génération",
    "executive_summary": "RÉSUMÉ EXÉCUTIF",
    "status": "STATUT JURIDIQUE",
    "explanation": "EXPLICATION EXPERTE",
    "details": "DÉTAILS TECHNIQUES",
    "similarity_analysis": "ANALYSE DE SIMILARITÉ",
    "registry_results": "RÉSULTATS DU REGISTRE",
    "name_col": "Nom",
    "sector_col": "Secteur",
    "desc_col": "Description",
    "score_col": "Score",
    "risk_col": "Risque",
    "export_pdf": "EXPORT PDF",
    "export_excel": "EXPORT EXCEL",
    "new_search": "NOUVELLE RECHERCHE",
    "brand_name": "Nom de la marque",
    "sector": "Secteur Économique",
    "decision": "Décision Stratégique",
    "recommendations": "Recommandations",
    "risk_none": "Aucun",
    "risk_low": "Faible",
    "risk_medium": "Modéré",
    "risk_high": "Élevé",
    "risk_critical": "Critique"
  },
  "name_check": {
    "title": "Vérification de Dénomination",
    "subtitle": "Audit juridique instantané & Validation stratégique",
    "connected_to": "Connecté au",
    "central_registry": "Registre Central",
    "brand_arbitrage": "Arbitrage de Marque",
    "description": "Notre moteur d'intelligence juridique analyse votre marque par rapport aux bases de données institutionnelles et aux modèles de similarité phonétique.",
    "multi_layer_audit": "Audit Multi-Couches",
    "check_1": "Vérification d'antériorité CNRC",
    "check_2": "Similarité phonétique (Match Engine)",
    "check_3": "Analyse de risque sectoriel",
    "check_4": "Disponibilité des domaines (.dz, .com)",
    "step1_label": "1. Nom de la marque",
    "name_placeholder": "EX: TECH DZ SOLUTIONS",
    "step2_label": "2. Secteur d’activité",
    "step3_label": "3. Informations complémentaires",
    "details_placeholder": "Précisez la nature exacte des produits ou services...",
    "analyzing": "ANALYSE EN COURS...",
    "analyze_button": "ANALYSER LA MARQUE",
    "database_info": "Base de données CNRC-2026",
    "compliance_guarantee": "Conformité Légale Garantie",
    "analyzing_title": "Génération du Rapport d'Audit",
    "analyzing_subtitle": "Analyse des registres CNRC & INAPI en cours...",
    "sectors": {
      "tech": "Technologie & Digital",
      "finance": "Finance & Fintech",
      "industry": "Industrie & Manufacturier",
      "construction": "BTPH & Infrastructure",
      "services": "Services Professionnels",
      "health": "Santé & Pharmaceutique",
      "trade": "Commerce & Distribution",
      "agro": "Agroalimentaire",
      "telecom": "Télécommunications",
      "other": "Autres Secteurs"
    },
    "errors": {
      "reserved": "Ce nom est déjà réservé dans votre session actuelle."
    },
    "engine": {
      "status": {
        "unavailable": "NON DISPONIBLE",
        "risky": "À RISQUE",
        "available": "DISPONIBLE"
      },
      "explanation": {
        "unavailable": "Nom déjà enregistré ou trop similaire à une entité existante.",
        "risky": "Nom partiellement similaire. Risque de confusion ou de rejet par le CNRC.",
        "available": "Nom conforme et disponible pour utilisation."
      }
    }
  },
  "name_result": {
    "title": "Rapport : {{name}}",
    "audit_ref": "Audit juridique officiel • REF : {{id}}",
    "archived": "ARCHIVÉ",
    "badge": "AUDIT DÉNOMINATION",
    "archived_btn": "Dans le coffre",
    "archive_btn": "Archiver",
    "share_btn": "Partager",
    "availability_label": "Disponibilité",
    "status": {
      "valid": "VALIDÉ",
      "risky": "À RISQUE",
      "critical": "CRITIQUE"
    },
    "main_title_available": "La dénomination est prête pour l'enregistrement.",
    "main_title_risky": "Risque d'antériorité détecté dans le secteur.",
    "ministry_stamp_1": "Ministère de",
    "ministry_stamp_2": "l'Industrie",
    "approved": "APPROUVÉ",
    "confidence_score": "Confiance Audit",
    "risk_level": "Niveau de Risque",
    "ip_protection": "Protection IP",
    "ip_protection_status": "OPTIMAL",
    "comparative_analysis": "Analyse Comparative",
    "registry_label": "Registres Nationaux Algériens (CNRC)",
    "conflict_phonetic": "Conflit phonétique et sectoriel détecté",
    "similarity": "SIMILARITÉ",
    "no_conflict_title": "Aucun conflit majeur détecté",
    "no_conflict_desc": "Le nom est libre d'antériorités critiques dans le secteur {{sector}}.",
    "system_decision": "Décision Système",
    "legal_arbitrage": "Arbitrage par Intelligence Légale",
    "recommended_action": "Action Recommandée :",
    "action_accept": "Vous pouvez procéder à la réservation du nom et à la constitution du dossier.",
    "action_modify": "Nous conseillons d'ajouter un qualificatif distinctif pour éviter tout rejet CNRC.",
    "action_reject": "Ce nom est trop proche d'une marque notoire. Un rejet est quasiment certain.",
    "reserve_btn": "Réserver la Dénomination",
    "launch_creation_btn": "Lancer la Création",
    "modify_project_btn": "Modifier le Projet",
    "digital_assets": "Actifs Digitaux Disponibles",
    "domain_available": "Disponible",
    "domain_taken": "Occupé",
    "validity_title": "Validité de l'Audit",
    "validity_desc": "72 Heures (Données CNRC Temps Réel)",
    "authenticity_title": "Vérifier l'authenticité",
    "authenticity_desc": "Scannez pour vérifier l'originalité du certificat sur le portail GSD.",
    "modal_title": "Nom réservé avec succès",
    "modal_desc": "Votre choix est enregistré dans votre session. Vous pouvez maintenant lancer la création administrative de votre entreprise.",
    "modal_create_btn": "Créer mon entreprise maintenant",
    "modal_close_btn": "Fermer",
    "modal_validity": "Réservation valide 24h",
    "modal_approved": "Décision Approuvée",
    "footer_advisory": "Avertissement : Ce rapport est un outil d'aide à la décision institutionnel. Il ne remplace pas l'avis d'un conseil juridique agréé.",
    "metrics": {
      "memorability": "Mémorabilité",
      "protection": "Protection Juridique",
      "availability": "Disponibilité",
      "memorability_desc": "Évalue la facilité avec laquelle votre nom peut être mémorisé par les clients.",
      "protection_desc": "Calcule la force juridique de la marque face aux concurrents.",
      "availability_desc": "Vérifie la disponibilité en temps réel dans les registres officiels."
    }
  },
  "export": {
    "pdf_header1": "RÉPUBLIQUE ALGÉRIENNE DÉMOCRATIQUE ET POPULAIRE",
    "pdf_header2": "MINISTÈRE DE L'INDUSTRIE ET DU COMMERCE - CHARIKATY GSD",
    "pdf_title": "CERTIFICAT D'AUDIT DE DÉNOMINATION",
    "pdf_ref": "RÉFÉRENCE",
    "pdf_details": "DÉTAILS DU PROJET",
    "pdf_name": "Dénomination",
    "pdf_sector": "Secteur d'activité",
    "pdf_date": "Date de l'audit",
    "pdf_decision": "DÉCISION",
    "pdf_favorable": "FAVORABLE",
    "pdf_unfavorable": "DÉFAVORABLE",
    "pdf_modification": "RECOMMANDATION DE MODIFICATION",
    "pdf_analysis_title": "ANALYSE DES ANTÉRIORITÉS (CNRC / INAPI)",
    "pdf_table_name": "Dénomination Conflicteuse",
    "pdf_table_sector": "Secteur",
    "pdf_table_similarity": "Similarité",
    "pdf_table_no_conflict": "Aucun conflit majeur détecté",
    "pdf_footer1": "Ce document est généré électroniquement et possède une valeur informative pour la constitution du dossier CNRC.",
    "pdf_footer2": "Toute reproduction doit conserver les filigranes d'origine.",
    "toast_pdf_success": "Rapport institutionnel PDF généré avec succès",
    "toast_excel_success": "Audit structuré Excel exporté",
    "toast_share_success": "Lien de l'audit copié dans le presse-papier",
    "toast_share_desc": "Vous pouvez maintenant le partager en toute sécurité.",
    "toast_archive_loading": "Archivage sécurisé dans le coffre-fort institutionnel...",
    "toast_archive_success": "Rapport archivé avec succès dans votre espace sécurisé",
    "toast_archive_error": "Erreur lors de l'archivage",
    "excel_summary_sheet": "Synthèse Audit",
    "excel_conflicts_sheet": "Conflits Détaillés",
    "excel_gov_sheet": "Gouvernance & Conseils",
    "excel_gov_title": "CONSEILS DE GOUVERNANCE ET CONFORMITÉ",
    "excel_gov_tip1_title": "1. PROTECTION DES MARQUES",
    "excel_gov_tip1_desc": "Il est fortement recommandé de déposer votre marque auprès de l'INAPI dès l'obtention du registre du commerce.",
    "excel_gov_tip2_title": "2. DOMAINE .DZ",
    "excel_gov_tip2_desc": "La priorité doit être donnée à l'enregistrement du nom de domaine en .dz pour asseoir votre identité numérique nationale.",
    "excel_gov_tip3_title": "3. ACTES SOCIAUX",
    "excel_gov_tip3_desc": "Veillez à ce que la dénomination soit identique dans tous vos actes (statuts, PV, factures).",
    "excel_audit_id": "ID AUDIT",
    "excel_system_label": "SYSTÈME",
    "excel_system_val": "CHARIKATY GSD v4.0 - MINISTÈRE DE L'INDUSTRIE",
    "excel_explication": "EXPLICATION"
  },
  "statutes_generator": {
    "title": "Générateur de Statuts",
    "subtitle": "Créez vos statuts personnalisés conformes au droit commercial algérien",
    "actions": {
      "reset": "Réinitialiser",
      "generate": "Générer les Statuts",
      "preview": "Aperçu",
      "download": "Télécharger PDF"
    },
    "sections": {
      "company_info": "Informations de la Société",
      "legal_form": "Forme Juridique",
      "capital": "Capital Social",
      "partners": "Associés & Actionnaires",
      "governance": "Gouvernance & Gérance"
    },
    "fields": {
      "name": "Dénomination Sociale",
      "name_placeholder": "Entrez le nom de la société",
      "activity": "Activité (Objet Social)",
      "activity_placeholder": "Décrivez l'activité principale",
      "duration": "Durée (Années)",
      "head_office": "Adresse du Siège Social",
      "head_office_placeholder": "Adresse complète en Algérie",
      "form_label": "Sélectionnez la Forme Juridique",
      "capital_amount": "Capital Total (DZD)",
      "share_value": "Valeur Nominale par Part/Action",
      "total_shares": "Nombre Total de Parts/Actions"
    },
    "forms": {
      "sarl": "SARL (Société à Responsabilité Limitée)",
      "eurl": "EURL (Entreprise Unipersonnelle à Responsabilité Limitée)",
      "spa": "SPA (Société Par Actions)",
      "snc": "SNC (Société en Nom Collectif)"
    },
    "validation": {
      "incomplete": "Veuillez remplir tous les champs obligatoires",
      "invalid_capital": "Le capital doit être d'au moins 100 000 DZD pour une SARL",
      "no_partners": "Au moins un associé est requis"
    }
  },
  "integrations_page": {
    "title": "Partenaires Intégrés",
    "description": "Les plateformes connectées à votre environnement entrepreneurial. Accédez aux services essentiels en toute sécurité.",
    "partners": {
      "etaxes": {
        "name": "E-Taxes",
        "desc": "Plateforme de gestion fiscale permettant la déclaration et le suivi des obligations fiscales."
      },
      "guichet": {
        "name": "Guichet Unique",
        "desc": "Système centralisé pour la création et la gestion administrative des entreprises."
      },
      "moustachir": {
        "name": "Moustachir Idarati",
        "desc": "Plateforme d’accompagnement administratif et de conseil pour les entrepreneurs."
      },
      "cnrc": {
        "name": "CNRC (Sidjilcom)",
        "desc": "Registre du commerce permettant la vérification et l’enregistrement des entreprises."
      },
      "sarfipay": {
        "name": "SarfiPay",
        "desc": "Solution de paiement électronique intégrée pour les transactions et services financiers."
      }
    },
    "status": {
      "operational": "Opérationnel",
      "connected": "Connecté",
      "certified": "Certifié",
      "active": "Actif",
      "coming_soon": "Intégration en cours"
    },
    "access_btn": "Accéder",
    "redirecting": "Redirection vers {{name}}...",
    "external_link_notice": "Vous allez être redirigé vers une plateforme externe sécurisée.",
    "ecosystem": {
      "title": "Connectivité Totale",
      "desc": "Charikaty fédère les meilleurs services numériques pour simplifier votre parcours de croissance."
    },
    "popup": {
      "title": "Prochainement",
      "desc": "Cette intégration est actuellement en cours de développement par nos équipes techniques.",
      "btn": "Compris"
    },
    "error": {
      "title": "Erreur de chargement",
      "description": "Impossible de charger les données des intégrations. Veuillez réessayer.",
      "reset": "Réessayer"
    },
    "options": {
      "yes": "Oui",
      "no": "Non"
    }
  },
  "genvest": {
    "portfolio": {
      "title": "Terminal de Portefeuille",
      "subtitle": "Gestion institutionnelle des actifs et analyse de performance en temps réel.",
      "real_mode": "Mode Réel",
      "simulation_mode": "Simulation",
      "sync_complete": "Synchronisation Terminée",
      "sync_success": "Données de marché synchronisées avec succès",
      "new_position": "Position",
      "tabs": {
        "overview": "Vue d'Ensemble",
        "analysis": "Analyses Avancées",
        "actions": "Exécution & Flux",
        "ceo_view": "Vue CEO",
        "analyst_view": "Vue Analyste",
        "execution_view": "Vue Exécution"
      },
      "executive_dashboard": "Tableau de Bord Exécutif",
      "historical_performance": "Performance Historique",
      "portfolio_label": "Portefeuille",
      "benchmark_label": "Benchmark Algérien",
      "strategic_allocation": "Allocation Stratégique",
      "risk_analysis": "Analyse des Risques Algorithmique",
      "diversification_score": "Score de Diversification",
      "metrics": {
        "volatility": "Volatilité (Ex-post)",
        "volatility_desc": "Risque historique annuel",
        "sharpe": "Sharpe Ratio",
        "sharpe_desc": "Performance / Risque",
        "var": "Value at Risk (95%)",
        "var_desc": "Perte maximale (1 jour)",
        "cvar": "Conditional VaR (95%)",
        "cvar_desc": "Déficit attendu",
        "return": "Rendement Attendu",
        "return_desc": "Projection à 12 mois",
        "drawdown": "Max Drawdown",
        "drawdown_desc": "Baisse historique maximale"
      },
      "position_management": "Gestion des Positions",
      "assets_under_management": "{{count}} Actifs sous Gestion",
      "execution_center": "Centre d'Exécution",
      "rebalance_audit": "Rééquilibrage & Audit",
      "execution_desc": "Mise à jour des positions selon la stratégie cible",
      "ai_audit": "Audit IA",
      "rebalance": "Rééquilibrer",
      "deposit_funds": "Déposer des fonds",
      "liquidate_all": "Tout Liquider",
      "flow_history": "Historique des Flux",
      "diversification_comment": "Votre portefeuille montre une forte diversification dans les secteurs stratégiques algériens.",
      "sync_in_progress": "Synchronisation des données de marché en cours...",
      "simulation": "Simulation",
      "allocation": {
        "by_type": "Allocation par Type",
        "by_type_desc": "Poids des classes d'actifs dans le portefeuille total",
        "by_sector": "Exposition Sectorielle",
        "by_sector_desc": "Concentration du capital par secteur d'activité"
      },
      "insights": {
        "ai_title": "Insights Genvest AI",
        "default_category": "Analyse de Portefeuille",
        "estimated_impact": "Impact Estimé",
        "rebalance_suggested": "Rééquilibrage Suggéré",
        "rebalance_desc": "Votre portefeuille a dérivé de sa cible. L'IA suggère {{count}} ajustements pour optimiser le couple rendement/risque.",
        "apply_rebalance": "Appliquer Rééquilibrage"
      },
      "stats": {
        "total_value": "Valeur Totale",
        "simulated": "Simulé",
        "performance_ytd": "Performance YTD",
        "assets_held": "Actifs Détenus",
        "cash_excluded": "Hors liquidités",
        "asset_alloc": "Allocation d'Actifs",
        "risk_score": "Score de Risque",
        "risk_level": "Niveau {{level}}",
        "diversification": "Diversification",
        "hhi_score": "Score HHI Optimisé",
        "portfolio_health": "Santé du Portefeuille",
        "health_excellent": "Excellente",
        "health_optimal": "Optimale",
        "health_low": "Faible",
        "sharpe_ratio": "Sharpe Ratio",
        "optimal": "Optimal",
        "max_drawdown": "Max Drawdown",
        "available_cash": "Liquidités Disponibles",
        "deposit": "Dépôt",
        "levels": {
          "LOW": "Faible",
          "MODERATE": "Modéré",
          "HIGH": "Élevé",
          "EXTREME": "Extrême"
        }
      },
      "inventory": {
        "title": "Inventaire des Actifs",
        "subtitle": "Détails complets de vos positions actuelles",
        "search_placeholder": "Rechercher un actif...",
        "add_button": "Ajouter",
        "table": {
          "asset": "Actif / Symbole",
          "type": "Type / Secteur",
          "qty": "Quantité",
          "price": "PAMP / Actuel",
          "total": "Valeur Totale",
          "performance": "Performance",
          "signal": "Signal IA",
          "actions": "Actions",
          "pamp_label": "PAMP: ",
          "hold": "Conserver",
          "buy": "Acheter",
          "sell": "Vendre",
          "analyzing": "Analyse...",
          "edit_tooltip": "Modifier position",
          "remove_tooltip": "Clôturer position"
        },
        "empty": {
          "title": "Aucun actif dans le registre institutionnel.",
          "action": "Importer premier actif"
        }
      },
      "performance": {
        "title": "Performance Relative",
        "simulated_projection": "PROJECTION SIMULÉE",
        "vs_benchmark": "vs BENCHMARK",
        "subtitle_simulated": "Modélisation prédictive basée sur le profil investisseur",
        "subtitle_real": "Comparaison dynamique de la Valeur Liquidative (NAV)",
        "simulated_data": "Données Simulées",
        "portfolio": "Portefeuille",
        "benchmark": "Benchmark (Indice DZD)",
        "alpha_label": "Surperformance",
        "legend_portfolio": "Alpha Portfolio",
        "legend_benchmark": "Indice Marché DZD"
      },
      "modals": {
        "asset": {
          "title_add": "Nouvel Investissement",
          "title_edit": "Gestion de l'Actif",
          "subtitle": "Configuration des paramètres institutionnels de l'actif",
          "name_label": "Nom de l'actif",
          "name_placeholder": "ex: Al-Djazair Growth",
          "symbol_label": "Ticker / Symbole",
          "symbol_placeholder": "ex: DZG-2026",
          "type_label": "Type d'actif",
          "sector_label": "Secteur Stratégique",
          "financial_data": "Données Transactionnelles",
          "qty_label": "Quantité",
          "avg_price_label": "Prix PAMP (Achat)",
          "current_price_label": "Prix Actuel",
          "volatility_label": "Volatilité Attendue",
          "inflation_label": "Protection Inflation",
          "submit_add": "Confirmer l'Investissement",
          "submit_edit": "Enregistrer les Modifications"
        }
      },
      "asset_types": {
        "EQUITY": "Actions",
        "EQUITY_desc": "Titres de capital d'entreprises",
        "BOND": "Obligations",
        "BOND_desc": "Titres de créance (État ou Entreprises)",
        "REAL_ASSET": "Immobilier",
        "REAL_ASSET_desc": "Immobilier, Agriculture, Industrie",
        "STARTUP_SHARE": "Startups",
        "STARTUP_SHARE_desc": "Capital-risque et participations directes"
      },
      "sectors": {
        "Technology": "Technologie",
        "Finance": "Finance",
        "Energy": "Énergie",
        "Healthcare": "Santé",
        "Consumer": "Consommation",
        "Real Estate": "Immobilier",
        "Government": "Gouvernement",
        "Agriculture": "Agriculture",
        "Industrie": "Industrie",
        "Communication": "Communication",
        "Etat": "État",
        "Immobilier": "Immobilier",
        "Technologie": "Technologie",
        "Gouvernement": "Gouvernement",
        "Other": "Autre"
      },
      "stress_testing": {
        "title": "Simulations de Crise (Stress Test)",
        "subtitle": "Analyse de résilience face aux chocs macroéconomiques majeurs.",
        "scenarios": {
          "RATES_HIKE": {
            "title": "Hausse des Taux (+200 bps)",
            "type": "Scénario Macro"
          },
          "INFLATION_SPIKE": {
            "title": "Choc Inflationniste (15%)",
            "type": "Scénario Macro"
          },
          "MARKET_CRASH": {
            "title": "Krach Boursier (-35%)",
            "type": "Scénario Macro"
          },
          "descriptions": {
            "RATES_HIKE": "Hausse de +200 bps : Correction sévère sur les actifs à long terme (obligations, immobilier) et compression des multiples de valorisation technologique.",
            "INFLATION_SPIKE": "Choc Inflationniste (15%) : Érosion massive du cash et des obligations nominales. Protection partielle via l'immobilier et les actifs réels.",
            "MARKET_CRASH": "Krach Boursier Systémique (-35%) : Effondrement des actifs risqués. Seule la poche obligataire souveraine offre une corrélation négative protectrice.",
            "empty": "Aucun impact estimé (Portefeuille vide)"
          }
        },
        "results": {
          "impact_estimated": "Impact Estimé",
          "severity": "Sévérité",
          "critical": "CRITIQUE",
          "moderate": "MODÉRÉE",
          "hedging_btn": "Simulation de Couverture"
        },
        "empty_state": "Sélectionnez un scénario pour lancer la simulation de crise"
      },
      "audit": {
        "title": "Audit de Conformité",
        "subtitle": "Rapport Institutionnel Genvest AI",
        "demo_warning": "Attention : Rapport basé sur des données de simulation (Mode Démo)",
        "global_status": "Statut Global",
        "integrity_status": "INTÈGRE",
        "last_check": "Dernière Vérification",
        "analysis_title": "Analyse des Points de Contrôle",
        "download_btn": "Télécharger PDF Certifié",
        "validate_btn": "Valider le Rapport",
        "footer_certification": "Certification conforme aux normes de l'Autorité de Régulation (conforme COSO)",
        "checks": {
          "allocation": {
            "title": "Limites d'Allocation Réglementaires",
            "desc": "Aucune classe d'actif ne dépasse les seuils prudentiels fixés par la stratégie."
          },
          "esg": {
            "title": "Conformité ESG & Éthique",
            "desc": "Score moyen du portefeuille : 84/100. Alignement fort avec les critères de finance durable."
          },
          "concentration": {
            "title": "Alerte de Concentration Sectorielle",
            "desc": "L'exposition sectorielle maximale est de {{percentage}}%."
          },
          "liquidity": {
            "title": "Ratio de Couverture Liquidités",
            "desc": "Vos liquidités représentent {{percentage}}% du total."
          }
        },
        "status": {
          "compliant": "CONFORME",
          "optimal": "OPTIMAL",
          "warning": "AVERTISSEMENT",
          "critical": "CRITIQUE"
        }
      },
      "transactions": {
        "title": "Historique des Transactions",
        "subtitle": "Archives complètes de vos mouvements de capitaux",
        "empty": "Aucune transaction enregistrée.",
        "table": {
          "date": "Date",
          "action": "Action",
          "asset": "Actif / Libellé",
          "qty": "Quantité",
          "price": "Prix Unitaire",
          "total": "Total",
          "status": "Statut"
        },
        "status": {
          "completed": "COMPLÉTÉ",
          "pending": "EN ATTENTE",
          "cancelled": "ANNULÉ"
        },
        "types": {
          "buy": "ACHAT",
          "sell": "VENTE",
          "dividend": "DIVIDENDE",
          "fee": "FRAIS",
          "deposit": "DÉPÔT",
          "withdraw": "RETRAIT"
        }
      }
    }
  },
  "finance": {
    "etaxes": {
      "portal_title": "Portail E-Taxes",
      "unified_interface": "Interface Unifiée",
      "partnership_prefix": "Intégration directe officielle DGI via ",
      "direct_link": "Connexion Directe",
      "nodes_dgi": "Noeud DGI Actif",
      "auth_sig": "Signature Numérique : ",
      "proto_ready": "Système Prêt",
      "syncing": "Synchronisation...",
      "unified_space": "Espace Fiscal Unifié",
      "secure_gateway": "Passerelle institutionnelle pour la gestion des obligations fiscales algériennes.",
      "dgi_apps": "Déclarez vos G50, IBS et TAP en un clic.",
      "open_portal": "Accéder au Portail DGI",
      "sync_progress": "Mise à jour des données",
      "verify_obligations": "Vérifier les Obligations",
      "gateway": "Passerelle DGI",
      "master_server": "Noeud Souverain",
      "compliance_deadlines": "Calendrier de Conformité Fiscale",
      "fiscal_year": "Exercice Fiscal",
      "action_required": "Action Requise",
      "file_closed": "Conforme",
      "pending": "En Attente",
      "decl_g50": "Déclaration G50",
      "acompte_prov": "Acompte Provisionnel IBS",
      "opening_doc": "Ouverture de la documentation DGI...",
      "dgi_doc": "Guide Officiel de la DGI",
      "connecting_expert": "Connexion avec un conseiller fiscal...",
      "direct_support": "Assistance Institutionnelle"
    },
    "advisor": {
      "engine": "Moteur d'Aide à la Décision",
      "fin_decision": " Hub de Décision Financière",
      "premium_hub": "Système souverain d'aide à la décision actif",
      "sync_real": "Synchroniser avec les données réelles",
      "sim_inputs": "Paramètres d'entrée de la simulation",
      "op_params": "Paramètres Opérationnels",
      "monthly_rev": "Chiffre d'Affaires Mensuel (DA)",
      "avail_liquidity": "Trésorerie Disponible (DA)",
      "fixed_costs": "Charges Fixes Mensuelles (DA)",
      "var_costs": "Charges Variables Mensuelles (DA)",
      "debt_service": "Service de la Dette Mensuel (DA)",
      "tax_prov": "Provisions Fiscales Mensuelles (DA)",
      "expected_inflows": "Entrées Prévues (30 Jours)",
      "upcoming_payments": "Paiements à Venir (30 Jours)",
      "inv_context": "Contexte d'Investissement",
      "capex": "Coût du Projet / Capex (DA)",
      "expected_roi": "Rendement Attendu - ROI (%)",
      "risk_profile": "Profil de Risque Requis",
      "analyze_data": "Analyser les Paramètres Financiers",
      "launch_ai": "Lancer la Simulation IA",
      "est_time": "Temps d'exécution estimé : ",
      "results_intelligence": "Résultats de Simulation & Intelligence Financière",
      "sim_pending": "Simulation en Attente",
      "config_params": "Configurez vos paramètres opérationnels et d'investissement ci-dessus puis lancez le moteur IA.",
      "ai_verdict": "Verdict de la Simulation IA",
      "optimal": "OPTIMAL",
      "prudence": "PRUDENCE",
      "critical": "CRITIQUE",
      "health_score": "Score de Santé Financière",
      "proj_roi": "ROI Attendu du Projet",
      "cash_pos": "Trésorerie Post-Investissement",
      "save": "Enregistrer la Décision",
      "key_indicators": "Indicateurs Clés Opérationnels",
      "revenue": "Chiffre d'Affaires Mensuel",
      "monthly": "Mensuel",
      "rev_flow": "Moyenne mensuelle du chiffre d'affaires opérationnel",
      "margin": "Marge",
      "net_op_perf": "Marge opérationnelle nette avant dette et impôts",
      "unlimited": "Illimité",
      "proj_fin_autonomy": "Autonomie financière projetée en mois",
      "dscr_ratio": "Ratio DSCR",
      "debt_cov_cap": "Capacité de couverture du service de la dette",
      "proj_balance": "Solde de Trésorerie Projeté (30 Jours)",
      "current_treasury": "Trésorerie Actuelle",
      "net_flow_30": "Flux Nets Attendus (30 Jours)",
      "debt_serv": "Remboursement Service Dette",
      "net_position": "Position Nette Projetée",
      "rational_analysis": "Analyse Rationnelle de l'IA",
      "internal_health": "Diagnostic de Santé Interne",
      "growth_potential": "Logique d'Investissement & Croissance",
      "sec_mitigation": "Sécurité & Atténuation des Risques",
      "strat_directives": "Directives Stratégiques",
      "impact": " Impact",
      "action_lever": "Activer le levier d'action",
      "risk_control": "Contrôle des Risques & Alertes",
      "secure_perimeter": "Périmètre Sécurisé",
      "no_crit_alert": "Aucun risque critique détecté dans la simulation actuelle.",
      "decision_archive": "Archives Décisionnelles (Session)",
      "empty_log": "Aucune décision enregistrée dans la session actuelle."
    },
    "reports": {
      "title": "Rapports Financiers",
      "desc": "Générez et analysez vos bilans, comptes de résultat et liasses fiscales.",
      "back": "Retour à la Console Finance",
      "detailed_mode": "Mode Détaillé",
      "activated": "ACTIVÉ",
      "synthetic": "SYNTHÉTIQUE",
      "processing": "Traitement en cours...",
      "start_analysis": "Lancer l'Analyse du Rapport",
      "hide_options": "Masquer les Options Avancées",
      "adv_options": "Afficher les Options Avancées",
      "dgi_audit": "Vérification pré-audit de conformité DGI",
      "include_drafts": "Inclure les brouillons et écritures temporaires"
    },
    "alertes": {
      "major": "Alerte Majeure",
      "optimization": "Alerte d'Optimisation",
      "tax": "Conformité Fiscale",
      "cash_flow": "Flux de Trésorerie & Liquilité",
      "cost": "Contrôle des Coûts",
      "performance": "Performance Opérationnelle",
      "score": "Score de Risque Global",
      "unified_risk_index": "Indice Unifié de Risque & Exposition",
      "severity_alert": "Alerte de Sévérité Active",
      "high_vigilance": "Vigilance Élevée Requise",
      "sys_stability": "Stabilité Optimale du Système",
      "financial_exposure": "Exposition Financière Estimée (DA)",
      "live_risk_engine": "Moteur d'Analyse de Risque en Direct",
      "audit_proto": "Protocole d'audit : ",
      "active": "ACTIF",
      "last_scan": "Dernier scan : ",
      "selected_alert": "Alerte sélectionnée",
      "selected_alerts": "Alertes sélectionnées",
      "bulk_processing": "CONTRÔLEUR D'ACTION GROUPÉE",
      "deselect_all": "Tout Désélectionner",
      "resolve": "Résoudre la sélection",
      "ignore": "Ignorer la sélection",
      "analyze": "Analyse Approfondie",
      "access": "Accéder au Module Cible",
      "threat_feed": "Flux d'Intelligence des Menaces & Risques",
      "search_ph": "Filtrer les alertes actives par niveau de menace, catégorie...",
      "select_all": "Sélectionner Toutes les Alertes",
      "urgent": "Remédiation Urgente Requise",
      "normal_opt": "Conseil d'Optimisation Normal",
      "no_signal": "Aucune alerte active ne correspond aux filtres",
      "regulation": "Contexte Réglementaire",
      "risk_severity": "Niveau de Gravité & Impact du Risque",
      "systemic_diag": "Diagnostic Systémique",
      "risk_drivers": "Facteurs de Risque & Causes Racines",
      "board_rec": "Recommandations du Conseil",
      "priority_opt": "Optimisation Prioritaire",
      "audit_trail": "Piste d'Audit & Journaux de Vérification",
      "pending_cfo": "Remédiation en attente d'approbation du CFO",
      "no_remediation": "Aucune action de remédiation n'a encore été prise.",
      "synth_grouped": "Tableau d'Action Synthétique",
      "dynamic_audit": "Audit dynamique de ",
      "vigilance_points": " points de vigilance",
      "exit_mode": "Quitter Sélection Multiple",
      "cum_impact": "Impact Financier Cumulé (DA)",
      "avg_gravity": "Indice de Gravité Moyen",
      "synth_rec": "Recommandations de Conseil Synthétiques",
      "resolve_all": "Résoudre Toutes les Alertes Sélectionnées",
      "context_nav": "Ouvrir le Module Contextuel",
      "pending_risk_analysis": "Sélectionnez une alerte active pour voir les détails.",
      "identify_threat": "Identifiez les menaces et optimisez la conformité.",
      "balance_solidity": "Solidité du Bilan",
      "tax_burden": "Indice de Charge Fiscale",
      "op_leverage": "Levier Opérationnel",
      "integrated_sys": "Scan de risque pleinement intégré avec les noeuds de la DGI.",
      "expert_help": "Besoin d'un conseil expert ?"
    },
    "evaluation": {
      "pot_score": "Score de Potentiel Marché",
      "risk_control_lbl": "Niveau de Risque & Contrôle",
      "stars": "STARS",
      "stable": "STABLE",
      "growth": "HAUTE CROISSANCE",
      "at_risk": "À RISQUE",
      "project_eval": "Projet d'Évaluation ",
      "sys_selection": "Moteur d'aide à la décision",
      "reset": "Réinitialiser la Simulation",
      "project_params": "Paramètres Opérationnels du Projet",
      "define_context": "Définissez les dimensions clés de votre projet pour l'évaluation IA.",
      "eval_name": "Nom de l'Évaluation",
      "ex_project": "ex. Lancement Plateforme Fintech",
      "sector": "Secteur d'Activité",
      "maturity_stage": "Stade de Maturité",
      "eval_profile": "Profil d'Évaluation",
      "launch_eval": "Lancer l'Évaluation",
      "update_analysis": "Mettre à jour l'Analyse",
      "team": "Équipe & Capacité d'Exécution",
      "market_pot": "Potentiel Marché & Demande",
      "bus_model": "Business Model & Viabilité",
      "innovation": "Innovation & Barrière Technologique",
      "feasibility": "Faisabilité Financière & Ops",
      "risk": "Périmètre Risques & Conformité",
      "analysis_verdict": "Verdict de l'Évaluation IA",
      "strat_interp": "Interprétation stratégique des indicateurs de votre projet.",
      "share_committee": "Partager avec le Comité",
      "score_lbl": "Score Global : ",
      "strengths": "Forces Systémiques Clés",
      "no_crit_strength": "Aucune force critique marquante. Travaillez sur l'optimisation.",
      "risk_zones": "Zones de Risque & Exposition Clés",
      "risks_controlled": "Tous les risques semblent correctement contrôlés dans cette simulation.",
      "rec_action_plan": "Plan d'Action Recommandé",
      "no_corr_measures": "Aucune mesure corrective générée pour le moment.",
      "perf_score": "Score de Performance Opérationnelle",
      "radar_profile": "Profil Radar de Maturité",
      "maturity_pillar": "Distribution des Piliers de Maturité",
      "decision_center": "Centre de Décision & Actions",
      "compare": "Comparer les Simulations",
      "excel": "Exporter Excel Simulation",
      "distribute_com": "Distribuer au Comité d'Investissement",
      "session_ranking": "Évaluations de la Session (",
      "report_dist": "Distribution Institutionnelle"
    }
  },
  "kpis_datas": {
    "current_rev_desc": "Chiffre d'affaires total généré durant l'exercice fiscal en cours.",
    "prev_rev_desc": "Chiffre d'affaires total généré durant l'exercice fiscal précédent.",
    "tot_costs": "Total des Charges Opérationnelles",
    "tot_costs_desc": "Somme des charges opérationnelles fixes et variables de la période.",
    "active": "Actif",
    "curr_assets_desc": "Actifs liquides ou convertibles en trésorerie à moins de 12 mois.",
    "curr_liab": "Passifs Circulants",
    "curr_liab_desc": "Dettes financières à court terme exigibles à moins de 12 mois.",
    "fin_audit": "Audit des Indicateurs Financiers",
    "perf_params": "Analysez vos ratios de bilan, marges et structure de capital en temps réel.",
    "engine": "Moteur KPI",
    "fin_data": "Paramètres d'Entrée des Données Financières",
    "quick_synth": "Synthèse des Ratios en Temps Réel",
    "est_gross_margin": "Marge Brute Estimée",
    "growth_ratio": "Ratio de Croissance",
    "run_audit": "Lancer l'Audit d'Analyse des Ratios",
    "sys_ready": "Système de calcul de performance prêt."
  },
  "partners_page": {
    "pending": "En Attente",
    "institutional_network": "Réseau de Partenaires Institutionnels",
    "our_partners": "Partenaires Officiels",
    "partners_desc": "Connectez-vous et collaborez avec des institutions certifiées et des réseaux professionnels.",
    "admin_mode_active": "Mode Administrateur Actif",
    "admin_sim": "Console de Simulation Admin",
    "pending_apps": "Candidatures de Partenariats en Attente",
    "validation_req": "Vérifiez les compétences et validez les demandes d'intégration au réseau.",
    "validate": "Valider la Candidature",
    "verified": "Vérifié",
    "consult": "Consulter le Profil",
    "dossier": "Dossier",
    "become_partner": "Rejoindre l'Écosystème",
    "apply_network": "Candidater au Réseau",
    "apply": "Soumettre la Candidature",
    "form_name": "Nom Complet",
    "function_title": "Fonction / Poste",
    "organization": "Organisation / Entreprise",
    "form_email": "Adresse Email Professionnelle",
    "desc_expertise": "Description de l'Expertise & Collaboration",
    "proof_doc": "Justificatif de Compétences / Document Officiel",
    "click_upload": "Cliquez pour uploader un document PDF, PNG ou JPG",
    "send_application": "Envoyer la Demande de Partenariat",
    "contact": "Contact",
    "active_partner": "Partenaire Actif du Réseau",
    "join_date": "Date d'Adhésion",
    "intervention_domains": "Domaines d'Intervention & Expertises",
    "secure_doc": "Documentation Sécurisée",
    "download": "Télécharger le Fichier",
    "inst_level": "Intégration de Niveau Institutionnel",
    "validated_exp": "Réseaux d'Experts Validés",
    "national_cov": "Couverture Opérationnelle Nationale"
  },
  "pricing": {
    "title": "Des Tarifs Clairs et Souverains",
    "subtitle": "Aucun frais caché. Modules SaaS premium, support d'experts et forfaits institutionnels adaptés à l'écosystème algérien.",
    "monthly": "Facturation Mensuelle",
    "yearly": "Facturation Annuelle (Économisez 15%)",
    "recommended": "Recommandé",
    "freemium_title": "Notre Modèle de Tarification",
    "freemium_desc": "Charikaty propose un modèle freemium modulaire, combiné à du conseil à la demande et des solutions sur-mesure pour les institutions.",
    "philosophy": {
      "saas": {
        "title": "Abonnements SaaS",
        "desc": "Accédez aux outils numériques de pointe, à la conformité automatisée et à vos tableaux de bord en temps réel."
      },
      "advisory": {
        "title": "Conseil Institutionnel",
        "desc": "Des experts juridiques, financiers et fiscaux à votre écoute pour auditer et guider votre structure."
      },
      "partnerships": {
        "title": "Partenaires de l'Écosystème",
        "desc": "Formules adaptées pour les incubateurs, accélérateurs et parcs technologiques."
      }
    },
    "plans": {
      "free": {
        "name": "Gratuit",
        "price": "0",
        "period": "DA/Mois",
        "desc": "Idéal pour les étudiants, la validation d'idées et les porteurs de projets.",
        "button": "Commencer Gratuitement",
        "features": [
          "Accès au Tableau de Bord de base",
          "1 Projet Actif",
          "Support Communautaire",
          "Requêtes IA Limitées",
          "Accès au Noyau Souverain"
        ]
      },
      "starter": {
        "name": "Starter",
        "price": "1 500",
        "price_year": "15 000",
        "period": "DA/Mois",
        "desc": "Pour les freelancers, auto-entrepreneurs et projets en phase d'amorçage.",
        "button": "Choisir Starter",
        "features": [
          "Tableau de Bord Avancé",
          "3 Projets Actifs",
          "Modèles de Documents Standards",
          "Co-pilote IA Lite",
          "Support par Email",
          "Indicateurs Financiers de base"
        ]
      },
      "pro": {
        "name": "Pro",
        "price": "4 500",
        "price_year": "45 000",
        "period": "DA/Mois",
        "desc": "Parfait pour les startups en croissance et les PME numériques.",
        "button": "Choisir Pro",
        "features": [
          "Projets Actifs Illimités",
          "Moteur Co-pilote IA Avancé",
          "Modules complets Juridique & Fiscal",
          "Vérifications pré-audit de conformité",
          "Support Prioritaire 24h/24 & 7j/7",
          "Intégrations API (Beta)"
        ]
      },
      "business": {
        "name": "Business",
        "price": "9 000",
        "price_year": "90 000",
        "period": "DA/Mois",
        "desc": "Pour les structures établies nécessitant des analyses complexes et espaces partagés.",
        "button": "Choisir Business",
        "features": [
          "Tout l'abonnement Pro",
          "Espace de Travail Multi-utilisateurs",
          "Rapports Financiers Avancés",
          "Tableau de Bord Investisseur dédié",
          "Exports Comptables",
          "Accès API prioritaire"
        ]
      },
      "enterprise": {
        "name": "Entreprise",
        "price": "Sur-mesure",
        "period": "Devis sur Demande",
        "desc": "Pour les groupes, incubateurs, universités et institutions publiques.",
        "button": "Contacter l'Équipe",
        "features": [
          "Connexion directe Guichet Unique DGI",
          "Synchronisation E-Taxes complète",
          "Options de déploiement On-Premise",
          "Gestionnaire de compte dédié & SLA",
          "Développements & Intégrations personnalisés",
          "Sessions de formation & onboarding"
        ]
      }
    },
    "consulting": {
      "title": "Conseil Institutionnel à la Demande",
      "subtitle": "Bénéficiez du support des meilleurs experts d'entreprise en Algérie.",
      "legal": {
        "title": "Conseil Juridique",
        "desc": "Droit des sociétés, rédaction de statuts sur-mesure et gouvernance de conseil.",
        "price": "15 000 DA",
        "duration": "1-3 jours"
      },
      "finance": {
        "title": "Conseil Financier",
        "desc": "Structuration de trésorerie, modèles financiers complexes, planification CAPEX.",
        "price": "20 000 DA",
        "duration": "2-4 jours"
      },
      "tax": {
        "title": "Conseil Fiscal",
        "desc": "Optimisation IBS/TAP, assistance aux déclarations de TVA et pré-audit.",
        "price": "18 000 DA",
        "duration": "1-2 days"
      },
      "strategy": {
        "title": "Stratégie Commerciale",
        "desc": "Entrée sur le marché algérien, directives de croissance et conformité locale.",
        "price": "30 000 DA",
        "duration": "1 semaine"
      },
      "request": "Demander une Consultation"
    },
    "services": {
      "investment": {
        "title": "Services d'Investissement GENVEST",
        "desc": "Charikaty agit en tant qu'interface stratégique pour le financement de startups, la mise en relation avec des business-angels et la levée de fonds. Nous offrons une sécurité juridique maximale et des audits de performance rigoureux pour vos pitchs."
      },
      "government": {
        "title": "Numérisation & Secteur Public",
        "desc": "Nous construisons des connecteurs API dédiés pour les administrations, universités et agences afin de faciliter l'enregistrement au CNRC, les déclarations CNAS et l'interopérabilité e-gouvernement."
      }
    },
    "faq": {
      "title": "Questions Fréquentes",
      "q1": "Comment fonctionne l'abonnement ?",
      "a1": "Vous pouvez opter pour une facturation mensuelle ou annuelle. Vous pouvez changer de formule à tout moment depuis votre tableau de bord.",
      "q2": "Mes déclarations fiscales sont-elles conformes ?",
      "a2": "Oui. Notre module E-Taxes est conçu en stricte conformité avec le Code Général des Impôts algérien et les normes de la DGI.",
      "q3": "Puis-je annuler mon abonnement ?",
      "a3": "Absolument. Vous pouvez résilier votre abonnement à la fin de la période de facturation en cours sans aucun frais de pénalité.",
      "q4": "Quels sont les modes de paiement acceptés ?",
      "a4": "Nous acceptons les cartes CIB, BaridiMob ainsi que les virements bancaires standard. Vos factures d'entreprise sont générées automatiquement."
    },
    "compare_features": "Comparer les Fonctionnalités",
    "feature": "Fonctionnalité",
    "free": "Gratuit",
    "starter": "Starter",
    "pro": "Pro",
    "business": "Business",
    "enterprise": "Entreprise",
    "payment": {
      "title": "Moyens de Paiement Acceptés",
      "cib": "Carte CIB",
      "baridi": "BaridiMob",
      "transfer": "Virement Bancaire"
    },
    "cta": {
      "title": "Prêt à numériser votre entreprise ?",
      "subtitle": "Rejoignez des milliers d'entrepreneurs algériens qui font confiance à Charikaty.",
      "start": "Commencer Maintenant",
      "demo": "Réserver une Démo",
      "contact": "Contacter l'Équipe"
    }
  }
}
